<template>
  <v-row v-if="profile.phone || profile.email">
    <v-col class="text-center">
      <v-btn
        class="mr-3"
        v-show="profile.phone"
        @click="phoneUser(profile.phone)"
        fab
        dark
        x-small
        color="secondary"
      >
        <v-icon dark>
          phone
        </v-icon>
      </v-btn>

      <v-btn
        v-show="profile.email"
        @click="emailUser(profile.email)"
        fab
        dark
        x-small
        color="secondary"
      >
        <v-icon dark>
          email
        </v-icon>
      </v-btn>
      <slot name="buttons" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import { IUser } from '@/types/models/user.model'
import { userProfileEvents } from '@/segmentAnalytics/connections'

@Component
export default class ProfileContact extends Vue {
  @Prop({ required: true }) profile: IUser

  phoneUser (phone: string) {
    userProfileEvents.trackPhoneTap(this.profile.id)
    window.location.href = `tel:${phone}`
  }

  emailUser (email: string) {
    userProfileEvents.trackEmailTap(this.profile.id)
    window.location.href = `mailto:${email}`
  }
}
</script>
